import { Link } from 'react-router-dom';

const BackLink = () => (
  <Link to="/" className="back">
    <svg
      width="30"
      height="30"
      viewBox="0 0 32 32"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M27 16H5" />
      <path d="M14 7L5 16L14 25" />
    </svg>
    Back
  </Link>
);

export default BackLink;
